export default __webpack_public_path__ + "static/media/weee-dark.7be5ae7b.svg";